<script setup lang="ts">
    defineProps<{
        a11yLabel?: string;
    }>();
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        :role="a11yLabel ? 'img' : 'presentation'"
        :aria-label="a11yLabel"
        :aria-hidden="!a11yLabel"
    >
        <path d="M12 3v12" />
        <path d="m17 8-5-5-5 5" />
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    </svg>
</template>
